const EmployeeClass = ["PT - Part Time", "FT - Full Time", "PTIN - Part Time Insurance Eligible"];
const EmployeeClass_ALL = ["ALL", "PT - Part Time", "FT - Full Time", "PTIN - Part Time Insurance Eligible"];

export const EMPLOYEE_CLASS = EmployeeClass;
export const EMPLOYEE_CLASS_ALL = EmployeeClass_ALL;
